import React from "react";

const ShikhonAbout = () => {
  const brandCyan = "#0ea5e9";
  const brandPurple = "#d946ef";

  return (
    <div
      style={{
        fontFamily: "'Inter', 'Segoe UI', Arial, sans-serif",
        color: "#1e293b",
        backgroundColor: "#ffffff",
        padding: "50px 0 70px",
        marginTop: "-50px",
      }}
    >
      <div style={{ maxWidth: "1440px", margin: "0 auto", padding: "0 20px" }}>
        {/* ================= 1. Hero / Header Section ================= */}
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            gap: "50px",
            alignItems: "center",
            marginBottom: "70px",
          }}
        >
          <div>
            <span
              style={{
                fontSize: "12px",
                fontWeight: "700",
                color: brandCyan,
                letterSpacing: "1.2px",
                marginBottom: "10px",
                display: "block",
                textTransform: "uppercase",
              }}
            >
              ✦ ACCESSIBLE SKILLS & EDUCATION
            </span>

            <h2
              style={{
                fontSize: "36px",
                lineHeight: "1.25",
                fontWeight: "800",
                color: "#0f172a",
                margin: "0 0 18px 0",
              }}
            >
              Empowering Learners Through{" "}
              <span style={{ color: brandPurple }}>Modern Skills</span>
            </h2>

            <p
              style={{
                color: "#64748b",
                lineHeight: "1.65",
                fontSize: "15px",
                marginBottom: "20px",
              }}
            >
              <strong style={{ color: brandCyan }}>Iconic Shikhon</strong> is a
              learning-focused initiative committed to creating accessible
              opportunities for education, skill building, and career
              development.
            </p>

            <p
              style={{
                color: "#64748b",
                lineHeight: "1.65",
                fontSize: "15px",
                marginBottom: "28px",
              }}
            >
              We bridge the gap between academic learning and industry demands
              by providing practical online training, expert mentorship, and
              certified professional courses tailored for students and job
              seekers.
            </p>

            <div
              style={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr",
                gap: "14px",
              }}
            >
              {[
                "Industry-Relevant Curriculum",
                "Expert Mentors & Instructors",
                "Hands-on Project Training",
                "Recognized Certificate Support",
              ].map((item, i) => (
                <div
                  key={i}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                    fontSize: "14px",
                    fontWeight: "600",
                    color: "#334155",
                  }}
                >
                  <span
                    style={{
                      color: brandPurple,
                      fontWeight: "800",
                      fontSize: "16px",
                    }}
                  >
                    ✓
                  </span>{" "}
                  {item}
                </div>
              ))}
            </div>
          </div>

          <div style={{ position: "relative" }}>
            <img
              src="https://images.unsplash.com/photo-1522202176988-66273c2fd55f?auto=format&fit=crop&w=1200&q=89"
              alt="Students learning and working together"
              style={{
                width: "100%",
                height: "380px",
                borderRadius: "16px",
                objectFit: "cover",
                display: "block",
                boxShadow: "0 10px 30px rgba(0,0,0,0.06)",
              }}
            />
            <div
              style={{
                position: "absolute",
                bottom: "-20px",
                left: "-20px",
                background: "#ffffff",
                padding: "16px 24px",
                borderRadius: "12px",
                boxShadow: "0 10px 30px rgba(0,0,0,0.12)",
                border: "1px solid #f1f5f9",
              }}
            >
              <span
                style={{
                  fontSize: "26px",
                  fontWeight: "800",
                  color: brandCyan,
                  display: "block",
                  lineHeight: "1",
                }}
              >
                25,000+
              </span>
              <span
                style={{
                  fontSize: "12px",
                  fontWeight: "600",
                  color: "#64748b",
                }}
              >
                Active Learners
              </span>
            </div>
          </div>
        </div>

        {/* ================= 2. Key Metrics Bar ================= */}
        <div
          style={{
            background: "#f8fafc",
            border: "1px solid #e2e8f0",
            padding: "32px 24px",
            borderRadius: "16px",
            display: "grid",
            gridTemplateColumns: "repeat(4, 1fr)",
            gap: "20px",
            marginBottom: "70px",
            textAlign: "center",
          }}
        >
          {[
            { value: "25,000+", label: "Students Trained" },
            { value: "50+", label: "Skill Courses" },
            { value: "95%", label: "Satisfaction Rate" },
            { value: "100+", label: "Expert Instructors" },
          ].map((stat, i) => (
            <div key={i}>
              <span
                style={{
                  fontSize: "32px",
                  fontWeight: "800",
                  color: brandPurple,
                  display: "block",
                  lineHeight: "1.1",
                  marginBottom: "4px",
                }}
              >
                {stat.value}
              </span>
              <span
                style={{
                  fontSize: "14px",
                  fontWeight: "600",
                  color: "#64748b",
                }}
              >
                {stat.label}
              </span>
            </div>
          ))}
        </div>

        {/* ================= 3. Learning Programs Grid ================= */}
        <div style={{ marginBottom: "70px" }}>
          <div style={{ textAlign: "center", marginBottom: "36px" }}>
            <span
              style={{
                fontSize: "12px",
                fontWeight: "700",
                color: brandPurple,
                textTransform: "uppercase",
                letterSpacing: "1px",
              }}
            >
              WHAT YOU CAN LEARN
            </span>

            <h2
              style={{
                fontSize: "32px",
                fontWeight: "800",
                margin: "8px 0 0 0",
                color: "#0f172a",
              }}
            >
              Our Core{" "}
              <span style={{ color: brandCyan }}>Learning Domains</span>
            </h2>
          </div>

          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(3, 1fr)",
              gap: "24px",
            }}
          >
            {[
              {
                title: "IT & Software Development",
                desc: "Web development, app programming, database management, and hands-on coding bootcamps.",
              },
              {
                title: "Digital Marketing & Growth",
                desc: "SEO, social media marketing, content creation, and performance marketing strategies.",
              },
              {
                title: "Graphics & UI/UX Design",
                desc: "Mastering Figma, Adobe Photoshop, Illustrator, and user interface design principles.",
              },
              {
                title: "Professional Language Skills",
                desc: "Spoken English, Arabic, and workplace communication courses for career development.",
              },
              {
                title: "Freelancing & Remote Work",
                desc: "Marketplace guides for Upwork, Fiverr, and securing global remote job opportunities.",
              },
              {
                title: "Vocational & Trade Skills",
                desc: "Practical technical training tailored for abroad employment and specialized trade jobs.",
              },
            ].map((service, idx) => (
              <div
                key={idx}
                style={{
                  background: "#ffffff",
                  padding: "26px 22px",
                  borderRadius: "14px",
                  border: "1px solid #e2e8f0",
                  boxShadow: "0 2px 8px rgba(0,0,0,0.02)",
                }}
              >
                <h3
                  style={{
                    margin: "0 0 10px 0",
                    fontSize: "18px",
                    fontWeight: "700",
                    color: "#0f172a",
                  }}
                >
                  {service.title}
                </h3>
                <p
                  style={{
                    margin: 0,
                    fontSize: "14px",
                    color: "#64748b",
                    lineHeight: "1.6",
                  }}
                >
                  {service.desc}
                </p>
              </div>
            ))}
          </div>
        </div>

        {/* ================= 4. Highlight Banner ================= */}
        <div
          style={{
            background: "#fdf4ff",
            border: "1px solid #f5d0fe",
            padding: "40px",
            borderRadius: "16px",
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            gap: "30px",
            alignItems: "center",
            marginBottom: "70px",
          }}
        >
          <div>
            <span
              style={{
                fontSize: "12px",
                fontWeight: "700",
                color: brandPurple,
                letterSpacing: "1px",
                textTransform: "uppercase",
              }}
            >
              LEARN AT YOUR OWN PACE
            </span>
            <h3
              style={{
                fontSize: "26px",
                fontWeight: "800",
                color: "#0f172a",
                margin: "8px 0 12px 0",
              }}
            >
              Interactive & Practical Learning Experience
            </h3>
            <p
              style={{
                fontSize: "15px",
                color: "#475569",
                lineHeight: "1.65",
                margin: 0,
              }}
            >
              Iconic Shikhon combines recorded video lessons, live Q&A sessions,
              real-world assignments, and dedicated community support so you
              build confidence alongside skills.
            </p>
          </div>

          <div
            style={{
              display: "grid",
              gridTemplateColumns: "1fr 1fr",
              gap: "16px",
            }}
          >
            {[
              {
                title: "Lifetime Access",
                desc: "Watch class materials anytime",
              },
              {
                title: "Live Mentorship",
                desc: "Get direct support from instructors",
              },
              {
                title: "Practical Projects",
                desc: "Build real portfolio projects",
              },
              {
                title: "Career Guidance",
                desc: "Resume & job placement support",
              },
            ].map((item, idx) => (
              <div
                key={idx}
                style={{
                  background: "#ffffff",
                  padding: "18px 16px",
                  borderRadius: "10px",
                  border: "1px solid #fae8ff",
                }}
              >
                <h4
                  style={{
                    margin: "0 0 4px 0",
                    fontSize: "15px",
                    fontWeight: "700",
                    color: brandPurple,
                  }}
                >
                  {item.title}
                </h4>
                <span
                  style={{
                    fontSize: "12px",
                    color: "#64748b",
                    lineHeight: "1.4",
                    display: "block",
                  }}
                >
                  {item.desc}
                </span>
              </div>
            ))}
          </div>
        </div>

        {/* ================= 5. Light CTA Banner ================= */}
        <div
          style={{
            background: "linear-gradient(90deg, #0ea5e9 0%, #d946ef 100%)",
            padding: "40px",
            borderRadius: "16px",
            color: "#ffffff",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            gap: "20px",
          }}
        >
          <div>
            <h3
              style={{
                margin: "0 0 8px 0",
                fontSize: "26px",
                fontWeight: "800",
                color: "#fff",
              }}
            >
              Start Learning with Iconic Shikhon
            </h3>
            <p style={{ margin: 0, fontSize: "15px", opacity: 0.95 }}>
              Enroll in our skill-building courses and build your future today.
            </p>
          </div>

          <button
            style={{
              background: "#ffffff",
              color: "#0f172a",
              border: "none",
              padding: "14px 28px",
              borderRadius: "8px",
              fontWeight: "700",
              cursor: "pointer",
              fontSize: "14px",
              whiteSpace: "nowrap",
            }}
          >
            Explore Courses →
          </button>
        </div>
      </div>

      {/* Responsive Styles */}
      <style>
        {`
          @media (max-width: 1024px) {
            div[style*="gridTemplateColumns: 1fr 1fr"] {
              grid-template-columns: 1fr !important;
            }
            div[style*="gridTemplateColumns: repeat(4, 1fr)"] {
              grid-template-columns: repeat(2, 1fr) !important;
            }
            div[style*="gridTemplateColumns: repeat(3, 1fr)"] {
              grid-template-columns: 1fr !important;
            }
          }

          @media (max-width: 640px) {
            div[style*="gridTemplateColumns: repeat(4, 1fr)"],
            div[style*="gridTemplateColumns: repeat(2, 1fr)"] {
              grid-template-columns: 1fr !important;
            }
            div[style*="justifyContent: space-between"] {
              flex-direction: column !important;
              align-items: flex-start !important;
            }
            h2 {
              font-size: 28px !important;
            }
          }
        `}
      </style>
    </div>
  );
};

export default ShikhonAbout;
